import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon } from 'lucide-react';
export function FocusSection() {
  return <section className="py-32 bg-schwarz text-weiss relative overflow-hidden" data-id="element-42">
      <div className="max-w-5xl mx-auto px-6 text-center relative z-10" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-44">
          <AwardIcon className="w-12 h-12 text-gold mb-8" data-id="element-45" />

          <h2 className="text-3xl md:text-5xl font-poppins font-bold mb-8 uppercase tracking-tight gold-shimmer" data-id="element-46">
            FOCUS Top-Mediziner Empfehlung
          </h2>

          <div className="w-24 h-px bg-gold mb-10" data-id="element-47" />

          <p className="text-lg md:text-xl text-gray-light font-lora leading-relaxed mb-12 max-w-3xl" data-id="element-48">
            Die drei Inhaber von edel & weiss:{' '}
            <strong className="text-weiss font-bold" data-id="element-49">
              Dr. Thomas Schwenk, Dr. Markus Striegel, und Dr. Johanna Herzog
              M.Sc.
            </strong>{' '}
            werden in der FOCUS-Top-Mediziner-Empfehlungsliste als führende
            Experten geführt.
          </p>

          <div className="flex flex-wrap justify-center gap-4 text-sm md:text-base text-weiss font-poppins" data-id="element-50">
            <span className="px-6 py-3 border border-gold/30 hover:border-gold transition-colors" data-id="element-51">
              Ästhetische Zahnheilkunde
            </span>
            <span className="px-6 py-3 border border-gold/30 hover:border-gold transition-colors" data-id="element-52">
              Kieferorthopädie
            </span>
            <span className="px-6 py-3 border border-gold/30 hover:border-gold transition-colors" data-id="element-53">
              CMD
            </span>
            <span className="px-6 py-3 border border-gold/30 hover:border-gold transition-colors" data-id="element-54">
              Sportzahnmedizin
            </span>
            <span className="px-6 py-3 border border-gold/30 hover:border-gold transition-colors" data-id="element-55">
              Parodontologie
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}